import { HiX } from 'react-icons/hi';
import { useBoolean } from 'usehooks-ts';

import HorizontalBannerAd from '@/tayara-kit/banners/HorizontalBannerAd';

import GoogleAd from '../GoogleAd';
// @ts-ignore

const categories = new Map();
categories.set('real-estate', 'immo');
categories.set('ImmoNeuf', 'immo');
categories.set('vehicles', 'cars');
categories.set('Véhicules', 'cars');
categories.set('tech', 'info');
categories.set('home-and-garden', 'maison');
categories.set('leisure-and-entertainment', 'loisir');
categories.set('clothing-and-well-being', 'habillement');
categories.set('jobs-and-services', 'emploi');
categories.set('Emploi et Services', 'emploi');
categories.set('Immobilier', 'immo');
categories.set('Informatique et Multimedia', 'info');
categories.set('Informatique et Multimedias', 'info');
categories.set('Habillement et Bien Etre', 'habillement');
categories.set('Pour la Maison et Jardin', 'maison');
categories.set('Loisirs et Divertissement', 'loisir');
categories.set('Multimédias', 'info');
categories.set('Maison & jardin', 'maison');
categories.set('Loisirs', 'loisir');
categories.set('Entreprises', 'emploi');
categories.set(undefined, 'homebanner');

type Param = {
  Scategorie: string | undefined;
  Region: string | undefined;
};

export interface TargtedBannersProps {
  category: string;
  param?: Param;
}

const TargtedBanners = ({ category }: TargtedBannersProps) => {
  const { value: googleAdClosed, setTrue: closeGoogleAd } = useBoolean(false);

  return (
    <>
      {categories.has(category) ? (
        !googleAdClosed && (
          <div
            aria-hidden
            tabIndex={-1}
            className="relative w-fit mx-auto mb-1 mt-2  overflow-hidden hidden lg:block"
          >
            <button
              tabIndex={-1}
              className="p-1 rounded-full bg-gray-100 text-gray-600 absolute top-3 left-4 border border-gray-300 "
              onClick={closeGoogleAd}
            >
              <HiX size={19} />
            </button>
            <span className="py-0.5 px-2 text-xs rounded-full bg-gray-100 text-gray-600 border border-slate-300 absolute flex justify-center top-4 left-14 mr-14">
              Publicité
            </span>

            <GoogleAd
              ad={{
                slot: '/118262226/C1_Desktop_1000x300',
                mapping: {
                  0: [1000, 300],
                },
                sizes: [[1000, 300]],
              }}
              className={'hidden lg:block h-full w-full overflow-hidden '}
            />
          </div>
        )
      ) : (
        <HorizontalBannerAd />
      )}
    </>
  );
};

export default TargtedBanners;
